export default {
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 浮点数验证
    validateFloat(rule, value, callback) {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g
      if (value === '') {
        callback(new Error('请输入内容'))
      } else if (!reg.test(value)) {
        callback(new Error('只能输入整数或小数'))
      } else {
        callback()
      }
    },
    // 整数验证
    validateInteger(rule, value, callback) {
      let reg = /^[+]{0,1}(\d+)$/g
      if (value === '') {
        callback(new Error('请输入内容'))
      } else if (!reg.test(value)) {
        callback(new Error('只能输入数字'))
      } else {
        callback()
      }
    },
    // 是否合法IP地址
    validateIP(rule, value, callback) {
      if (value === '' || value === undefined || value === null) {
        callback()
      } else {
        let reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
        if ((!reg.test(value)) && value !== '') {
          callback(new Error('请输入正确的IP地址'))
        } else {
          callback()
        }
      }
    },
    // 是否手机号码或者固话
    validatePhoneNumber(rule, value, callback) {
      let reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/
      if (value === '' || value === undefined || value == null) {
        callback()
      } else {
        if ((!reg.test(value)) && value !== '') {
          callback(new Error('请输入正确的手机或者固话号码'))
        } else {
          callback()
        }
      }
    },
    // 是否固话
    validateTelPhoneNumber(rule, value, callback) {
      let reg = /0\d{2}-\d{7,8}/
      if (value === '' || value === undefined || value === null) {
        callback()
      } else {
        if ((!reg.test(value)) && value !== '') {
          callback(new Error('请输入正确的固话号码（格式：区号+号码,如010-1234567）'))
        } else {
          callback()
        }
      }
    },
    // 是否手机号码
    validateMobilePhoneNumber(rule, value, callback) {
      let reg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (value === '' || value === undefined || value === null) {
        callback()
      } else {
        if ((!reg.test(value)) && value !== '') {
          callback(new Error('请输入正确的手机号码'))
        } else {
          callback()
        }
      }
    },
    // 是否身份证号码
    validateIdNo(rule, value, callback) {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (value === '' || value === undefined || value === null) {
        callback()
      } else {
        if ((!reg.test(value)) && value !== '') {
          callback(new Error('请输入正确的身份证号码'))
        } else {
          callback()
        }
      }
    },
    // 是否邮箱
    validateEMail(rule, value, callback) {
      let reg = /^([a-zA-Z0-9]+[-_]?)+@[a-zA-Z0-9]+[a-z]+$/
      if (value === '' || value === undefined || value === null) {
        callback()
      } else {
        if (!reg.test(value)) {
          callback(new Error('请输入正确的邮箱地址'))
        } else {
          callback()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/validator-mixin.js